<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.container {
  // height: 760px;
  border: 1px solid #dcdfe6;
  padding: 20px 35px;
  background: #fff;
  margin-bottom: 10px;
  > div {
    display: flex;
  }
  .talk {
    width: 300px;
    height: 580px;
    border: 1px solid #e7e7eb;
    position: relative;
  }
  .custom {
    flex: 1;
    margin-left: 10px;
    position: relative;
  }
}
.head {
  position: relative;
  width: 100%;
  > div {
    position: absolute;
    bottom: 0;
    height: 42px;
    text-align: center;
    line-height: 42px;
    color: #fff;
    width: 100%;
  }
}
.foot {
  height: 50px;
  width: 100%;
  position: absolute;
  bottom: 0;
  border-top: 1px solid #e7e7eb;
  box-sizing: border-box;
  background: url(../../../assets/foot.png) no-repeat 0 0;
  padding-left: 43px;
  > div {
    float: left;
    height: 100%;
    border-left: 1px solid #e7e7eb;
    text-align: center;
    line-height: 50px;
  }
  .add {
    color: #616161;
  }
  .select {
    border: 1px solid #44b549;
    color: #44b549;
    position: relative;
    z-index: 999;
    &:nth-child(n + 2) > div {
      border-top: none;
    }
  }
  &.size1 > div {
    width: 100%;
  }
  &.size2 > div {
    width: 50%;
  }
  &.size3 > div {
    width: 33.33%;
  }
}
.li {
  position: relative;
  & > .select {
    height: 100%;
  }
}
.children {
  width: 100%;
  position: absolute;
  bottom: 60px;
  background: #fafafa;
  border: 1px solid #d0d0d0;
  .add2 {
    color: #616161;
    height: 50px;
    overflow: hidden;
  }
  .jiantou {
    position: absolute;
    left: 50%;
    margin-left: -6px;
  }
  .select {
    margin: -1px;
  }
}
.item {
  height: 50px;
  > div {
    margin: 0 0.5em;
    height: 100%;
  }
  &:nth-child(n + 2) > div {
    border-top: 1px solid #e7e7eb;
  }
}
.btn {
  margin-top: 30px;
  text-align: center;
}
.btn1 {
  justify-content: space-around;
}
.fit {
  width: 100%;
  object-fit: cover;
  vertical-align: top;
}
.out {
  bottom: -6px;
  display: inline-block;
  width: 0;
  height: 0;
  border-width: 6px;
  border-style: dashed;
  border-color: transparent;
  border-bottom-width: 0;
  border-top-color: #d0d0d0;
  border-top-style: solid;
}
.in {
  bottom: -5px;
  display: inline-block;
  width: 0;
  height: 0;
  border-width: 6px;
  border-style: dashed;
  border-color: transparent;
  border-bottom-width: 0;
  border-top-color: #fafafa;
  border-top-style: solid;
}
.wrp {
  position: absolute;
  top: 545px;
  left: 0;
  .edit_out {
    position: absolute;
    display: inline-block;
    width: 0;
    height: 0;
    border-width: 12px;
    border-style: dashed;
    border-color: transparent;
    border-left-width: 0;
    border-right-color: #e7e7eb;
    border-right-style: solid;
    left: 0;
  }
  .edit_in {
    left: 1px;
    border-right-color: #f4f5f9;
  }
}
.edit {
  padding-left: 12px;
  position: relative;
  .wrap {
    min-height: 580px;
    padding: 0 20px 20px;
    background-color: #f4f5f9;
    border: 1px solid #e7e7eb;
  }
}
.title {
  border-bottom: 1px solid #e7e7eb;
  padding: 9px 0;
}
.blue {
  color: #173bcf;
}
.tishi {
  text-align: center;
  padding-top: 200px;
  color: #8d8d8d;
}
.el-input {
  width: 300px;
}
.group {
  margin: 30px 0 0;
}
.tip {
  color: #8d8d8d;
  margin-top: 10px;
}
.menu_content {
  padding: 16px 20px 30px;
  border: 1px solid #e7e7eb;
  background-color: #fff;
}
label {
  width: 90px;
  display: inline-block;
}
</style>

<template>
  <div>
    <AlertTips />
    <div class="container clearfix">
      <div>
        <div class="fl">
          <div class="talk">
            <div class="head">
              <img class="fit" src="@/assets/head.png" alt />
              <div>{{nickName}}</div>
            </div>
            <div
              class="foot clearfix"
              :class="arr.length ? (arr.length == 1 ? 'size2' : 'size3') : 'size1'"
              v-if="splice"
            >
              <div class="li" v-for="(item,index) in arr" :key="index">
                <div
                  class="pointer line1"
                  :class="{select: select === index && select2 === -1}"
                  @click="changeSelect(index)"
                >
                  <i class="el-icon-tickets" v-if="item.subMenu && item.subMenu.length"></i>
                  {{item.name}}
                </div>
                <div class="children" v-if="select === index">
                  <template v-if="item.subMenu">
                    <div
                      class="pointer item"
                      :class="{select: select2 == index}"
                      v-for="(item,index) in item.subMenu"
                      :key="index"
                      @click="changeSelect2(index)"
                    >
                      <div class="line1">{{item.name}}</div>
                    </div>
                  </template>
                  <div
                    v-show="!item.subMenu || item.subMenu.length < 5"
                    class="add2 item pointer"
                    @click="add2(index)"
                  >
                    <div>
                      <i class="el-icon-plus"></i>
                    </div>
                  </div>
                  <i class="jiantou out"></i>
                  <i class="jiantou in"></i>
                </div>
              </div>
              <div
                v-show="arr.length < 3"
                class="add pointer"
                :class="{select: !arr.length}"
                @click="add"
              >
                <i class="el-icon-plus"></i>
                <span class="ml10" v-show="!arr.length">添加菜单</span>
              </div>
            </div>
            <div v-else>
              <draggable
                class="foot"
                :list="arr"
                group="sort"
                :class="arr.length == 1 ? 'size1' : (arr.length == 2 ? 'size2' : 'size3')"
              >
                <div class="li" v-for="(item,index) in arr" :key="index">
                  <div class="pointer line1" @click="changeSelect(index)">
                    <i class="el-icon-s-unfold"></i>
                    {{item.name}}
                  </div>
                  <div
                    class="children"
                    v-if="select == index && item.subMenu && item.subMenu.length"
                  >
                    <draggable :list="item.subMenu" group="sort" draggable=".item">
                      <div class="item pointer" v-for="(item,index) in item.subMenu" :key="index">
                        <div class="line1">
                          <i class="el-icon-s-unfold"></i>
                          {{item.name}}
                        </div>
                      </div>
                    </draggable>
                    <i class="jiantou out"></i>
                    <i class="jiantou in"></i>
                  </div>
                </div>
              </draggable>
            </div>
          </div>
          <div class="btn" v-if="arr.length">
            <el-button :disabled="arr.length == 1" @click="paixu">{{splice ? '菜单排序' : '完成'}}</el-button>
          </div>
        </div>
        <div class="custom" v-show="arr.length">
          <div class="tishi" v-if="!splice">请通过拖拽左边的菜单进行排序</div>
          <div class="tishi" v-else-if="!select && select !== 0">点击左侧菜单进行编辑操作</div>
          <div class="edit" v-else>
            <div class="wrap">
              <div class="title clearfix">
                <span class="fl">{{form.name}}</span>
                <span class="fr pointer blue" @click="del">{{select2 == -1 ? '删除菜单' : '删除子菜单'}}</span>
              </div>
              <div class="tip" v-show="form.subMenu">已添加子菜单,仅可设置菜单名称</div>
              <div class="group">
                <label for>{{select2 == -1 ? '菜单名称' : '子菜单名称'}}</label>
                <el-input v-model="form.name" size="small" maxlength="10"></el-input>
                <p class="tip pl90">仅支持中英文和数字，字数不超过5个汉字或10个字母</p>
              </div>
              <div v-if="!form.subMenu">
                <div class="mt30 mb30">
                  <label for>{{select2 == -1 ? '菜单内容' : '子菜单内容'}}</label>
                  <el-radio-group v-model="form.type" @change="changeType">
                    <el-radio :label="1">发送消息</el-radio>
                    <el-radio :label="2">跳转网页</el-radio>
                    <el-radio :label="11">跳转小程序</el-radio>
                  </el-radio-group>
                </div>
                <div v-show="form.type == 1">
                  <wxEditor ref="wxEditor"></wxEditor>
                </div>
                <div v-if="form.type == 2 && form.detail">
                  <div class="menu_content clearfix">
                    <div class="tip">订阅者点击该子菜单会跳到以下链接</div>
                    <div class="mt10">
                      <label for>页面地址</label>
                      <el-input size="small" v-model="form.detail.url" maxlength="500"></el-input>
                    </div>
                  </div>
                </div>
                <div v-else-if="form.type == 11 && form.detail">
                  <div class="menu_content clearfix">
                    <div class="tip">订阅者点击该子菜单会跳到以下小程序</div>
                    <div class="mt10">
                      <label for>小程序AppID</label>
                      <el-input size="small" v-model="form.detail.appId" maxlength="100"></el-input>
                    </div>
                    <div class="mt10">
                      <label for>小程序路径</label>
                      <el-input size="small" v-model="form.detail.pagePath" maxlength="100"></el-input>
                    </div>
                    <div class="tip ml90">例: pages/index/index</div>
                    <div class="mt10">
                      <label for>备用网页</label>
                      <el-input size="small" v-model="form.detail.appUrl" maxlength="500"></el-input>
                    </div>
                    <div class="tip ml90 fl">旧版微信客户端无法支持小程序,用户点击菜单时将会打开备用网页</div>
                  </div>
                </div>
                <div class="mt30" v-if="showFans">
                  <fans-label
                    :customTag="form.customTag"
                    :customTags="form.customTags"
                    :id="id"
                    @tagsChange="val => form.customTags = val"
                    @changeChoose="val => form.customTag = val"
                  ></fans-label>
                </div>
              </div>
            </div>
            <div class="wrp">
              <i class="edit_out"></i>
              <i class="edit_out edit_in"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="btn1">
        <el-button @click="submit1">保存菜单</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import wxEditor from '@/components/wxEditor';
import fansLabel from '@/components/fansLabel';
import draggable from 'vuedraggable';
import AlertTips from '@/components/alertTips';
import store from 'store';
import utils from '@/utils.js';

import { nextTick } from 'q';
export default {
  components: {
    wxEditor,
    fansLabel,
    draggable,
    AlertTips,
  },
  props: ['id'],
  computed: {},
  watch: {
    'form.detail.url': {
      handler(val, oldval) {
        let iLen = utils.getStringLength(val);
        console.log(iLen);
        if (iLen > 500) {
          this.form.detail.url = oldval;
        }
      },
    },
    'form.detail.appId': {
      handler(val, oldval) {
        let iLen = utils.getStringLength(val);
        console.log(iLen);
        if (iLen > 100) {
          this.form.detail.appId = oldval;
        }
      },
    },
    'form.detail.pagePath': {
      handler(val, oldval) {
        let iLen = utils.getStringLength(val);
        console.log(iLen);
        if (iLen > 100) {
          this.form.detail.pagePath = oldval;
        }
      },
    },
    'form.detail.appUrl': {
      handler(val, oldval) {
        let iLen = utils.getStringLength(val);
        console.log(iLen);
        if (iLen > 500) {
          this.form.detail.appUrl = oldval;
        }
      },
    },
  },
  data() {
    return {
      arr: [],
      flag: 1,
      select: 0,
      select2: -1,
      splice: true,
      form: {},
      showFans: true,
      nickName: '',
    };
  },
  created() {
    this.nickName = '';
    setTimeout(() => {
      this.nickName = store.get('oaNickName');
    }, 300);
  },
  async mounted() {
    this.getData();
  },
  watch: {
    'form.key': {
      handler(val) {
        this.showFans = false;
        setTimeout(() => {
          this.showFans = true;
        }, 30);
      },
      deep: true,
    },
    'form.name': {
      handler(val, oldval) {
        let iLen = utils.getStringLength(val);
        if (iLen > 10) {
          this.form.name = oldval;
        }
      },
      deep: true,
    },
  },
  methods: {
    async getData() {
      let res = await this.$http.get(`/api/${this.id}/menu`);
      this.arr = res;
      if (this.arr.length) {
        this.form = this.arr[0];
        if (this.form.type == 1 && this.form.detail) {
          this.setData();
        }
      }
      console.log(this.arr);
    },
    changeCustomTag() {},
    changeType(val) {
      console.log(val);
      if (!this.form.detail) {
        this.$set(this.form, 'detail', {});
      }
      switch (val) {
        case 1:
          if (!this.form.detail.replyType) {
            this.$set(this.form.detail, 'replyType', 1);
            this.$set(this.form.detail, 'material', {
              content: { text: '["",""]' },
            });
          } else {
            this.setData();
          }
          break;
        case 2:
          if (!this.form.detail.url) {
            this.$set(this.form.detail, 'url', '');
          }
          break;
        case 11:
          if (!this.form.detail.appId) {
            this.$set(this.form.detail, 'appId', '');
            this.$set(this.form.detail, 'pagePath', '');
            this.$set(this.form.detail, 'appUrl', '');
          }
          break;
      }
    },
    paixu() {
      this.splice = !this.splice;
      this.select = '';
      this.select2 = -1;
    },
    add() {
      if (this.form.type == 1) {
        this.saveData();
      }
      this.arr.push({
        name: '菜单名称',
        type: null,
        subMenu: null,
      });
      this.select = this.arr.length - 1;
      this.select2 = -1;
      this.changeForm(this.select);
    },
    async add2(index) {
      if (this.form.type == 1) {
        this.saveData();
      }
      if (this.arr[index].subMenu) {
        this.arr[index].subMenu.push({
          name: '子菜单名称',
          subMenu: null,
          type: null,
        });
      } else if (this.arr[index].type) {
        let res = await this.$confirm(
          '添加子菜单后，一级菜单的内容将被清除。确定添加子菜单？',
          '子菜单确认',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          },
        );
        if (res) {
          this.arr[index].type = null;
          this.arr[index].subMenu = [
            {
              name: '子菜单名称',
              subMenu: null,
              type: null,
            },
          ];
        }
      } else {
        this.arr[index].subMenu = [
          {
            name: '子菜单名称',
            subMenu: null,
            type: null,
          },
        ];
      }

      this.select2 = this.arr[index].subMenu.length - 1;
      this.changeForm(this.select, this.select2);
    },
    changeSelect(index) {
      if (this.form.type == 1) {
        this.saveData();
        this.$refs.wxEditor.clear();
      }
      this.select = index;
      this.select2 = -1;
      this.changeForm(index);
    },
    changeSelect2(index) {
      console.log(this.form);
      if (this.form.type == 1) {
        this.saveData();
        this.$refs.wxEditor.clear();
      }
      this.select2 = index;
      this.changeForm(this.select, index);
    },
    saveData() {
      let data = this.$refs.wxEditor.getData('key');
      console.log(data);
      if (
        (data.replyType == 1 && JSON.parse(data.material.content.text)[0]) ||
        (data.replyType != 1 && Object.keys(data.material).length)
      ) {
        this.$set(this.form, 'detail', data);
      }
    },
    setData() {
      this.$nextTick(() => {
        this.$refs.wxEditor.setData(this.form.detail);
      });
    },
    changeForm(index, index2) {
      if (index2 || index2 === 0) {
        this.form = this.arr[index].subMenu[index2];
      } else {
        this.form = this.arr[index];
      }
      if (this.form.type == 1 && this.form.detail) {
        this.setData();
      } else if (this.form.type && !this.form.detail) {
        this.$refs.wxEditor.clear();
      }
    },
    async submit1() {
      if (this.form && this.form.type == 1) {
        this.saveData();
      }
      for (let i in this.arr) {
        if (this.arr[i].subMenu && this.arr[i].subMenu.length) {
          let subMenu = this.arr[i].subMenu;
          for (let j in subMenu) {
            if (
              !subMenu[j].type ||
              (subMenu[j].type == 1 &&
                ((subMenu[j].detail.replyType == 1 &&
                  !JSON.parse(subMenu[j].detail.material.content.text)[0]) ||
                  (subMenu[j].detail.replyType != 1 &&
                    !Object.keys(subMenu[j].detail.material).length))) ||
              (subMenu[j].type == 2 && !subMenu[j].detail.url) ||
              (subMenu[j].type == 11 &&
                (!subMenu[j].detail.appId ||
                  !subMenu[j].detail.pagePath ||
                  !subMenu[j].detail.appUrl))
            ) {
              this.$message.error(`请完善自定义菜单`);
              this.select = i - 0;
              this.select2 = j - 0;
              this.changeForm(this.select, this.select2);
              return;
            }
          }
        } else if (
          !this.arr[i].type ||
          (this.arr[i].type == 1 &&
            ((this.arr[i].detail.replyType == 1 &&
              !JSON.parse(this.arr[i].detail.material.content.text)[0]) ||
              (this.arr[i].detail.replyType != 1 &&
                !Object.keys(this.arr[i].detail.material).length))) ||
          (this.arr[i].type == 2 && !this.arr[i].detail.url) ||
          (this.arr[i].type == 11 &&
            (!this.arr[i].detail.appId ||
              !this.arr[i].detail.pagePath ||
              !this.arr[i].detail.appUrl))
        ) {
          this.$message.error(`请完善自定义菜单`);
          this.select = i - 0;
          this.select2 = -1;
          this.changeForm(this.select);
          return;
        }
      }
      console.log(this.arr);
      let res = await this.$http.put(`/api/${this.id}/menu`, this.arr);
      if (res) {
        this.$message.success('保存成功');
      }
    },
    async del() {
      if (this.select2 == -1) {
        let res = await this.$confirm(
          `删除后“${this.arr[this.select].name}”菜单下设置的内容将被删除`,
          '删除确认',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          },
        );
        if (res) {
          this.arr.splice(this.select, 1);
          this.form = {};
        }
      } else {
        let res = await this.$confirm(
          `删除后“${this.arr[this.select].name}”菜单下设置的内容将被删除`,
          '删除确认',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          },
        );
        if (res) {
          if (this.arr[this.select].subMenu.length == 1) {
            this.arr[this.select].subMenu = null;
          } else {
            this.arr[this.select].subMenu.splice(this.select2, 1);
          }
          this.form = {};
        }
      }
      this.select = '';
      this.select2 = -1;
    },
  },
};
</script>
